import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { brandService } from '../../services/brandService';

export const useGetBrandDetailBySlug = slug => {
  return useQuery({
    enabled: !!slug,
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.brand.detail_by_slug, slug],
    queryFn: () =>
      brandService.brandDetailBySlug(slug).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
